import React, { useEffect, useRef, useState } from 'react';
import "@/v2/pages/Plans/components/plan-switcher/switcher.css";
import { trackPlansPageEvent } from '@/data/utils/plansPageAnalytics';

const PlanSwitcher = ({ onToggle }) => {
	const [isYearly, setIsYearly] = useState(true);
	const monthlyRef = useRef(null);
	const yearlyRef = useRef(null);
	const [bgStyle, setBgStyle] = useState({ width: 0, left: 0 });

	useEffect(() => {
		if (monthlyRef.current && yearlyRef.current) {
			const activeRef = isYearly ? yearlyRef.current : monthlyRef.current;
			setBgStyle({
				width: activeRef.offsetWidth,
				left: activeRef.offsetLeft
			});
		}
	}, [isYearly]);

	const handleToggle = value => {
		trackPlansPageEvent({
			eventName: 'billing_cycle_switched',
			billingCycle: value ? 'yearly' : 'monthly',
			source: 'plans_page_switcher',
			meta: { previousCycle: isYearly ? 'yearly' : 'monthly' }
		});
		setIsYearly(value);
		onToggle(value);
	};

	return (
		<>
			<div className="switch-container">
				<div className="switch-bg" style={bgStyle}></div>
				<span ref={monthlyRef} className="switch-label" onClick={() => handleToggle(false)}>
					Monthly
				</span>

				<span ref={yearlyRef} className="switch-label" onClick={() => handleToggle(true)}>
					Yearly <span className="discount">Up to 45% OFF</span>
				</span>
			</div>
		</>
	);
};

export default PlanSwitcher;
